// Okabe-Ito colorblind-safe palette, with yellow swapped for dark gray so every swatch is legible on white.
export const COLOR_OPTIONS = [
    { name: 'Blue', hex: '#0072B2' },
    { name: 'Vermillion', hex: '#D55E00' },
    { name: 'Bluish Green', hex: '#009E73' },
    { name: 'Reddish Purple', hex: '#CC79A7' },
    { name: 'Orange', hex: '#E69F00' },
    { name: 'Sky Blue', hex: '#56B4E9' },
    { name: 'Dark Gray', hex: '#595959' },
];

export const DEFAULT_COMPARISON_COLORS = {
    first: COLOR_OPTIONS[0].hex,
    second: COLOR_OPTIONS[1].hex,
};
